export const getCustomFieldFilter = state => state.customField.filter
